import { useApi } from './useApi'

export const useGruposInvitados = () => {
  const api = useApi()

  // { guestGroups: [{ id, codigo, cantidad, encargado, whatsapp }] }
  const getGruposInvitados = () => api.get('/api/guest-groups')

  const createGrupoInvitado = (payload) => api.post('/api/guest-groups', payload)

  const updateGrupoInvitado = (id, payload) => api.put(`/api/guest-groups/${id}`, payload)

  const deleteGrupoInvitado = (id) => api.del(`/api/guest-groups/${id}`)

  const bulkImportGruposInvitados = (rows) => api.post('/api/guest-groups/bulk-import', { rows })

  return {
    getGruposInvitados,
    createGrupoInvitado,
    updateGrupoInvitado,
    deleteGrupoInvitado,
    bulkImportGruposInvitados,
  }
}
